











import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import store from "@/shared/core/store";

@Component
export default class LegalLayout extends Vue {
  logoUrl: string | null = null;

  mounted() {
    const shared = store.state.settings;
    if (shared.Mainlogo) {
      this.logoUrl = shared.Uploads + "/" + shared.Mainlogo;
    }
    if (shared.ButtonsColor) {
      document.documentElement.style.setProperty("--main-color", shared.ButtonsColor);
    }
    if (shared.FontFamily) {
      document.documentElement.style.setProperty("--main-family", shared.FontFamily);
    }
  }
}
